export default __webpack_public_path__ + "static/weekday-c88910bb72571e35727590877d9557f8.gif";